import React, { useState, useEffect } from 'react';
import { workspaceRegistry } from './WorkspaceRegistry';
import { WingmanWorkspaceId } from './WorkspaceContract';
import { useThemeStore } from '../ui/theme/useThemeStore';
import './WorkspaceHost.css';

export const WorkspaceHost: React.FC = () => {
  const [activeId, setActiveId] = useState<WingmanWorkspaceId | null>(() => workspaceRegistry.getActiveWorkspaceId());
  const themeMode = useThemeStore((state) => state.themeMode);
  const isLight = themeMode === 'LIGHT_EXECUTIVE' || (themeMode as string) === 'light';

  useEffect(() => {
    return workspaceRegistry.subscribe((newId) => {
      setActiveId(newId);
    });
  }, []);

  if (!activeId) return null;

  const registration = workspaceRegistry.get(activeId);
  if (!registration) return null;

  const ActiveComponent = registration.component;

  return (
    <div 
      className="wingman-workspace-host"
      data-testid="wingman-workspace-host"
      data-active-workspace={activeId}
      data-theme={isLight ? 'light' : 'dark'}
      role="dialog"
      aria-modal={activeId === 'real-estate-intelligence' ? false : true}
      aria-label={activeId === 'real-estate-intelligence' ? 'Real Estate Intelligence' : undefined}
    >
      <ActiveComponent onClose={() => workspaceRegistry.closeWorkspace()} />
    </div>
  );
};
